import React from 'react'
import {formatAmount} from '../../services/utils'

interface BillingBalanceSummaryProps {
  balance?: number
  isEndingBalance: boolean
}

function formatSummaryAmount(amount: number) {
  if (amount < 0) {
    return `-${formatAmount(Math.abs(amount))}`
  } else {
    return formatAmount(amount)
  }
}

const BillingSummary = ({
  balance,
  isEndingBalance
}: BillingBalanceSummaryProps) => {
  const currentBalance = balance !== null ? formatSummaryAmount(balance) : ' - '
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="uppercase text-primary font-bold">
        {isEndingBalance ? 'Ending Balance:' : 'Current Balance:'}
      </div>
      <div className="uppercase text-4xl font-bold mt-2">{currentBalance}</div>
    </div>
  )
}

export default BillingSummary
